import { matchPath } from 'react-router';

export function getLocationSelector(state) {
    return state.router.location;
}

export function getPathnameSelector(state) {
    return getLocationSelector(state).pathname;
}

export function getSearchSelector(state) {
    return getLocationSelector(state).search;
}

export function getStateSelector(state) {
    return getLocationSelector(state).state;
}

export function getMatchesSelector(state, path) {
    const pathname = getPathnameSelector(state);
    return matchPath(pathname, { path });
}

export function getBrowserPathnameSelector() {
    return window.location.pathname;
}
